import 'whatwg-fetch';
import { getBaseUrl } from '../../../../home24/core/config';
import {
  classNames,
  AB_TEST_ATTR_NAME,
  AB_TEST_VALUE,
  DY_STRATEGY_IDS,
  RECOMMENDATIONS_URL
} from '../constants/recommendations';

/**
 * @description
 * Create fetch request for fetching recommendations
 *
 * @param {String} [url] - relative url
 *
 * @returns {Promise}
 */
const createFetchRequest = url =>
  fetch(`${getBaseUrl()}/${url}`, {
    headers: {
      'x-requested-with': 'XMLHttpRequest'
    }
  }).then(res => res.json());

/**
 * @description
 * Retrieve recommendations either from our endpoint or dynamic yields according to AB test value
 *
 * @param {String} [productIdentifier] - product sku
 * @param {String} [langCode] - language code
 *
 * @returns {Promise} List of recommendations
 */
export const getRecommendationsData = (productIdentifier, langCode) =>
  new Promise((resolve, reject) => {
    const currentABTestValue = document
      .querySelector(`[${AB_TEST_ATTR_NAME}]`)
      .getAttribute(AB_TEST_ATTR_NAME);

    const handleFetchResponse = response => {
      if (response.success && response.success === false) {
        return reject(response.message);
      }
      resolve(response);
    };

    switch (currentABTestValue) {
      case AB_TEST_VALUE.INHOUSE_SLIDER:
        const url = `${RECOMMENDATIONS_URL.INHOUSE}&sku=${productIdentifier}`;
        createFetchRequest(url)
          .then(handleFetchResponse)
          .catch(err => reject(err));
        break;
      case AB_TEST_VALUE.DY_SLIDER:
        if (!DY_STRATEGY_IDS[DY.scsec]) {
          return reject(
            `DY strategy could not be found by section ${DY.scsec}.`
          );
        }

        DYO.recommendationWidgetData(
          DY_STRATEGY_IDS[DY.scsec],
          {
            context: {
              lng: langCode,
              type: 'PRODUCT',
              data: [productIdentifier]
            }
          },
          (err, data) => {
            if (err) {
              reject(err);
            } else if (data.slots.length > 0) {
              const skus = data.slots.map(slot => slot.item.sku);
              const url = `${RECOMMENDATIONS_URL.DY}${skus
                .map(sku => `&skus[]=${sku}`)
                .join('')}`;
              createFetchRequest(url)
                .then(handleFetchResponse)
                .catch(err => reject(err));
            }
          }
        );
        break;
      default:
        resolve(null);
    }
  });

/**
 * Returns boolean value whether a given response is from DYO.recommendationWidgetData
 * @param {Object} response data for recommendations slider
 */
export const isRecommendationsResponseDYO = ({ wId, fId }) =>
  [wId, fId].every(prop => typeof prop === 'number');

/**
 * Tracks DYO recommendations element queried from the existing DOM
 */
export const trackDYORecommendations = () => {
  const recommendationsSliderNode = document.querySelector(
    `.${classNames.SLIDER_CONTAINER}`
  );
  if (!recommendationsSliderNode) {
    console.error(
      `DY Slider: Element .${
        classNames.SLIDER_CONTAINER
      } could not be found in the DOM.`
    );
  } else {
    DYO.recommendations.registerElements(recommendationsSliderNode);
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/functions/recommendations.js
 **/